// メニュー・UI・会話場面の字 = 同梱の Zen Old Mincho (2026-11-01 作者 font=1・記録 docs/research/2026-11-01-ui-font-ship.md)。
//   字体 = public/fonts/zen-old-mincho-600.woff2 (使う字だけに抜き出した SemiBold 1本・書き出し = scripts/build_fonts.mjs)。
//   太さの指定 (400・600・bold) はどれもこの1本で描く (太さの範囲で登録するので、太字を作って潰さない)。
//   読み終わるまで・読めない時は OS の明朝で描く (下の並びの2番目から)。
//   開発版 ?uiFont=os = 前の版 (字体を読まず、ゴシックだった所もゴシックに戻す)。
export const UI_FONT_NAME = 'Zen Old Mincho'
export const UI_FONT_URL = '/fonts/zen-old-mincho-600.woff2?v=1'

/** 明朝の並び (同梱の字 → OS の明朝)。 */
export const UI_SERIF = `"${UI_FONT_NAME}","Yu Mincho","YuMincho","Hiragino Mincho ProN",serif`
const OLD_SANS = '"Hiragino Sans","Yu Gothic UI","Segoe UI",sans-serif'

let bundled = true
/** 前はゴシックだった所 (タイトルと幕間のメニュー・会話場面の絵の字など) の並び。配布版 = 明朝にそろえる。 */
export function uiSans(): string { return bundled ? UI_SERIF : OLD_SANS }
export function setUiFont(v: string | null): void { bundled = v !== 'os' }
export function uiFontBundled(): boolean { return bundled }

let loading: Promise<void> | null = null
/** 字体を読んで document.fonts へ足す (起動時に1回・最初の絵より前に待つ)。node・前の版では何もしない。 */
export function loadUiFont(): Promise<void> {
  if (loading) return loading
  if (!bundled || typeof FontFace === 'undefined' || typeof document === 'undefined') return (loading = Promise.resolve())
  const face = new FontFace(UI_FONT_NAME, `url(${UI_FONT_URL}) format("woff2")`, { weight: '100 900', display: 'block' })
  loading = face.load().then(f => { document.fonts.add(f) }).catch(() => {})
  return loading
}
